import { Fragment } from "react";
import "./SignUp.css";
import logo from "./logo.png";
import SignUpPhoto from "./signup.png";

const SignUp = () => {
  return (
    <Fragment>
      <div className="signup-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="signup-container">
          <div className="img-box">
            <img src={SignUpPhoto} alt="SingUp" />
          </div>
          <div className="form-box">
            <div className="form-text">
              <h2>Sign Up</h2>
              <p>Please Enter Your Details To Sign Up...</p>
            </div>
            <form className="signup-form">
              <div>
                <input
                  type="text"
                  id="firstName"
                  placeholder="First Name"
                  className="form-input"
                />
              </div>
              <div>
                <input
                  type="text"
                  name=""
                  id="lastName"
                  placeholder="LastName"
                  className="form-input"
                />
              </div>
              <div>
                <input
                  type="email"
                  id="email"
                  className="form-input"
                  placeholder="Email"
                />
              </div>
              <div>
                <input
                  type="password"
                  id="password"
                  placeholder="Password"
                  className="form-input"
                />
              </div>
              <div>
                <input
                  type="password"
                  id="confirmPassword"
                  placeholder="Confirm Password"
                  className="form-input"
                />
              </div>
              <div className="form-footer">
                <button type="submit" className="signup-btn">
                  Sign Up
                </button>
              </div>
            </form>
            <div className="footer">
              <p>Already have account?</p>
              <a href="">login</a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SignUp;
